module.exports = __webpack_public_path__ + "img/stop_btn.9b393ec0.png";